export const claimStatus = [
  {label: 'Submitted', value: '1'}, 
  {label: 'In-Review', value: '2' }, 
  {label: 'Approved', value: '3'}, 
  {label: 'Rejected', value: '4'}, 
  {label: 'Payout Verification', value: '5'}, 
  {label: 'Paid', value: '6'}, 
]

export const globalFilterTypes = [
  {label:'asset_type',type:'assetTypeOptions'},
  {label:'asset_model',type:'assetModelOptions'},
  {label:'serial_number',type:'assetsOptions'},
]
// Claim Fleet
export const claimFleetHd = [
  { id:'asset_type', label: 'Asset(s)', sortOption: false },
  { id: 'major_assembly', label: 'Assembly', sortOption: false },
  { id:'shop_visit', label: 'Event/Shop Visit', sortOption: false },
  { id:'submission_date', label: 'Submission Date', sortOption: true },
  { id:'sv_cost', label: 'SV Cost', sortOption: true },
  { id:'status', label: 'Claim Status', sortOption: true },
  { id:'claim_amount', label: 'Claim Amount', sortOption: false },
  { id:'amount_paid', label: 'Approved Amount', sortOption: true },
  { id:'approved_by', label: 'Updated By', sortOption: false },
  { id:'action', label: 'Action', sortOption: false },
]

export const claimFleetFilterOps = {
  asset_type : {
    inputType: 'dropdown',
    placeholder: 'Select Asset Type',
    title: 'Asset Type',
    options: [],
    labelKey: 'name',
    valueKey: 'id',
  },
  asset_model: {
    inputType: 'dropdown',
    placeholder: 'Select Asset Model',
    title: 'Asset Model',
    options: [],
    labelKey: 'name',
    valueKey: 'id',
  },
  serial_number: {
    inputType: 'dropdown',
    placeholder: 'Select Serial No.',
    title: 'Serial No.',
    options: [],
    labelKey: 'serial_number',
    valueKey: 'id',
  },
  major_assemblies: {
    inputType: 'dropdown',
    placeholder: 'Select Assembly',
    options: [],
    labelKey: 'name',
    valueKey: 'id',
    title:'Assembly',
  },
  status: {
    inputType: 'dropdown',
    placeholder: 'Select Claim Status',
    options: claimStatus,
    title:'Claim Status',
    labelKey: 'label',
    valueKey: 'value',
  },
  start_date:{
    inputType: 'date',
    title: 'Claim Start Date',
  },
  end_date:{
    inputType: 'date',
    title: 'Claim End Date',
  },
};

// Claim List
export const claimListHd = [
  { id: 'major_assembly', label: 'Assembly', sortOption: false },
  { id:'shop_visit', label: 'Event/Shop Visit', sortOption: false },
  { id:'submission_date', label: 'Submission Date', sortOption: true },
  { id:'sv_cost', label: 'SV Cost', sortOption: true },
  { id:'status', label: 'Claim Status', sortOption: true },
  { id:'claim_amount', label: 'Claim Amount', sortOption: false },
  { id:'amount_paid', label: 'Approved Amount', sortOption: true },
  { id:'approved_by', label: 'Updated By', sortOption: false },
  { id:'action', label: 'Action', sortOption: false },
]
export const claimFilterOps = {
  status: {
    inputType: 'dropdown',
    placeholder: 'Select Claim Status',
    options: claimStatus,
    title:'Claim Status',
    labelKey: 'label',
    valueKey: 'value',
  },
  start_date:{
    inputType: 'date',
    title: 'Claim Start Date',
  },
  end_date:{
    inputType: 'date',
    title: 'Claim End Date',
  },
};